const downloadFile = (url, filename) => {
  const xhr = new XMLHttpRequest()
  xhr.responseType = 'blob'
  xhr.onload = (event) => {
    const blob = xhr.response
    doDownload(blob, filename)
  }
  xhr.open('GET', url)
  xhr.send()
}

const doDownload = (data, name = 'inspire_school.pdf') => {
  const blob1 = new Blob([data], { type: 'octet-stream' })
  const href = URL.createObjectURL(blob1)
  const a = Object.assign(document.createElement('a'), {
    href,
    style: 'display: none',
    download: name
  })
  document.body.appendChild(a)
  a.click()
  URL.revokeObjectURL(href)
  a.remove()
}

const useDownload = () => {
  return { downloadFile }
}

export default useDownload
